module.exports = __webpack_public_path__ + "img/signature-graphiteGreen.2fe0f9c2.png";